export default __webpack_public_path__ + "static/media/SobreNos_Credibilidade 1.aa7b780f.svg";